// react
import { type ReactNode, useState } from 'react';

// shared components
import { initializeApplicationInsights } from '@/components/application-insights/ApplicationInsightsService';
import CookiePreferenceModal, {
  type CookieConsent,
} from '@/components/application-insights/CookiePreferenceModal';

// components
import {
  CookiePreferencesContext,
  type CookiePreferencesContextValue,
} from '@/contexts/CookiePreferencesContext';

/**
 * Owns the cookie preferences modal's open/closed state and renders the
 * modal itself, exposing `openCookiePreferences` app-wide via context so
 * any component (settings menu, navigation footer, etc.) can trigger it
 * without prop drilling.
 */
export default function CookiePreferencesProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [cookieModalOpenRequestId, setCookieModalOpenRequestId] = useState<
    number | null
  >(null);

  const openCookiePreferences = () => {
    setCookieModalOpenRequestId(Date.now());
  };

  const value: CookiePreferencesContextValue = { openCookiePreferences };

  return (
    <CookiePreferencesContext.Provider value={value}>
      {children}
      <CookiePreferenceModal
        key={cookieModalOpenRequestId ?? 'cookie-preferences-initial'}
        openRequestId={cookieModalOpenRequestId}
        onConsent={(consent: CookieConsent) => {
          if (consent === 'analytics') {
            initializeApplicationInsights();
          }
        }}
      />
    </CookiePreferencesContext.Provider>
  );
}
